export const userRole = ['admin', 'employee', 'agentAdmin', 'agent']
export const USER_ADMIN = 'admin'
export const USER_EMPLOYEE = 'employee'
export const AGENT_ADMIN = 'agentAdmin'
export const AGENT = 'agent'
